import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Site } from '../../../../../common/constants/siteList'
import { ILocationParams } from '../../../../../common/reducers/reactRouterLocation'
import { commaStyleString } from '../../../../../common/utils/formatString'

import Checkbox from '@envato/foundation-checkbox'
import * as styles from './filterBoolean.module.css'

interface IProps extends RouteComponentProps<any> {
  type: string
  label: string
  count: number
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

const FilterBoolean = ({
  type,
  label,
  count,
  locationParams,
  makeSearchLink,
  history
}: IProps & RouteComponentProps<any>) => {
  const isChecked = !!locationParams[type]

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkedValue = event.target.checked
    const newQuery = { ...locationParams }
    delete newQuery.page

    if (checkedValue) {
      newQuery[type] = '1'
    } else {
      delete newQuery[type]
    }

    history.push(makeSearchLink(newQuery) + '#content')
  }

  return (
    <div className={styles.root}>
      <Checkbox checked={isChecked} onChange={onChange}>
        {label}
      </Checkbox>
      <span className={styles.count}>{commaStyleString(count, ',')}</span>
    </div>
  )
}

export const FilterBooleanComponent = FilterBoolean

export default withRouter<IProps>(FilterBoolean)
